import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'components/Luxkit/Button/TextButton'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import { getInclusionIcon } from 'lib/getInclusionIcon'
import React from 'react'
import { useState } from 'react'

interface Props {
  amenities: Array<{icon: string, text: string}>
  offerUrl?: string
  title: string
}

function SearchRentalAmenitiesModal({ amenities, offerUrl, title }: Props) {
  const [modal, setModal] = useState(false)
  const toggle = (e : React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    setModal(!modal)
  }

  return (<>
    <BodyText onClick={toggle} variant="medium" weight="bold" colour="primary" underline>{`View all ${amenities.length} amenities`}</BodyText>
    <ModalBase isOpen={modal} size="small" onClose={toggle}>
      <ModalHeader title={title} onCloseButtonClick={toggle} />
      <ModalBody>
        <ModalContent>
          <Heading variant="heading6">Your handpicked inclusions:</Heading>
          <VerticalSpacer gap={8} />
          {amenities.map((inclusion) => {
            const InclusionIcon = getInclusionIcon(inclusion.icon)
            return (
              <BodyTextBlock
                key={inclusion.text}
                format="titlecase"
                variant="medium"
                startIcon={<InclusionIcon data-testid={inclusion.icon} size="S" />}
              >
                {inclusion.text}
              </BodyTextBlock>
            )
          })}
        </ModalContent>
      </ModalBody>
      {!!offerUrl &&
        <ModalFooter>
          <CSSBreakpoint min="sm">
            <Group direction="horizontal-reverse">
              <TextButton kind="primary" fit="auto" to={offerUrl}>View offer</TextButton>
            </Group>
          </CSSBreakpoint>
          <CSSBreakpoint max="xs">
            <TextButton kind="primary" fit="full-width" to={offerUrl}>View offer</TextButton>
          </CSSBreakpoint>
        </ModalFooter>
        }
    </ModalBase>
  </>)
}

export default SearchRentalAmenitiesModal
